import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { devicesApi } from '@/shared/redux/api/assets/devices/devices-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateDeviceTags = () => {
  const dispatch = useAppDispatch();

  const invalidateDeviceTags = (
    deviceId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          devicesApi.util.invalidateTags([
            { type: 'Device', id: 'LIST' },
            'Groups',
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          devicesApi.util.invalidateTags([
            { type: 'Device', id: deviceId },
            { type: 'DeviceConnectivityStatus', id: deviceId },
            { type: 'Device', id: 'LIST' },
            'Groups',
          ]),
        );
        break;
    }
  };

  return {
    invalidateDeviceTags,
  };
};
